export const RAALocation = {
    Burgenland: "Burgenland",
    Kärnten: "Innsbruck",
    Niederösterreich: "Linz",
    Oberösterreich: "Wien",
    Salzburg:"Salzburg",
    Steiermark:"Steiermark",
    Tirol:"Tirol",
    Vorarlberg:"Vorarlberg",
    Wien:"Wien",
};



export default [
    {
        RAALocation: RAALocation.Burgenland,
        Hauptstadt: 8,
        Land: 15

    },
    {
        RAALocation: RAALocation.Kärnten,
        Hauptstadt: 36,
        Land: 31

    },
    {
        RAALocation: RAALocation.Niederösterreich,
        Hauptstadt: 19,
        Land: 98

    },
    {
        RAALocation: RAALocation.Oberösterreich,
        Hauptstadt: 123,
        Land: 82

    },
    {
        RAALocation: RAALocation.Salzburg,
        Hauptstadt: 72,
        Land: 22

    },
    {
        RAALocation: RAALocation.Steiermark,
        Hauptstadt: 142,
        Land: 64

    },
    {
        RAALocation: RAALocation.Tirol,
        Hauptstadt: 81,
        Land: 47

    },
    {
        RAALocation: RAALocation.Vorarlberg,
        Hauptstadt: 12,
        Land: 30

    },
    {
        RAALocation: RAALocation.Wien,
        Hauptstadt: 1388,

    },
]